import React, { createContext, useContext } from "react";
import { useRadio } from "./useRadio";

// Radio Jawsel tingkat aplikasi: satu pemutar audio untuk semua halaman, sehingga siaran tidak putus
// saat warga pindah dari peta kota ke Alun-alun atau tempat publik lain.
const Ctx = createContext(null);

export function RadioProvider({ children }) {
  const radio = useRadio();
  return <Ctx.Provider value={radio}>{children}</Ctx.Provider>;
}

export const useRadioCtx = () => useContext(Ctx);
